import { changeAppState } from "../../../../../../common/appState";
import { fetchPost } from "../../../../../../common/util/fetch";
import { RelatedUser } from "../../../types";

export async function fetchUnfriend(myUserId: number, toUserId: number) {
    const relatedUsers = await fetchPost<
        { myUserId: number; toUserId: number },
        RelatedUser[]
    >("api/Friend/Unfriend", { myUserId, toUserId });

    if ("error" in relatedUsers) {
        return;
    }
    changeAppState("relatedUsers", relatedUsers);
}

export async function fetchCancelRequest(myUserId: number, toUserId: number) {
    const relatedUsers = await fetchPost<
        { myUserId: number; toUserId: number },
        RelatedUser[]
    >("api/Friend/CancelFriendRequest", { myUserId, toUserId });

    if ("error" in relatedUsers) {
        return;
    }
    changeAppState("relatedUsers", relatedUsers);
}

export async function fetchAddFriend(myUserId: number, toUserId: number) {
    const result = await fetchPost<
        { myUserId: number; toUserId: number },
        {
            friendsLimit: "ok" | "MyFriendsLimit";
            relatedUsers: RelatedUser[];
        }
    >("api/Friend/SendFriendRequest", { myUserId, toUserId });

    if ("error" in result) {
        return;
    }
    changeAppState("relatedUsers", result.relatedUsers);

    if (result.friendsLimit === "MyFriendsLimit") {
        changeAppState("friendsLimitDialogState", { type: "myLimit" });
    }
}

export async function fetchApprove(myUserId: number, requesterUserId: number) {
    const result = await fetchPost<
        { myUserId: number; requesterUserId: number },
        {
            friendsLimit: "ok" | "MyFriendsLimit" | "TheirFriendsLimit";
            relatedUsers: RelatedUser[];
        }
    >("api/Friend/ApproveFriendRequest", { myUserId, requesterUserId });

    if ("error" in result) {
        return;
    }
    changeAppState("relatedUsers", result.relatedUsers);

    switch (result.friendsLimit) {
        case "MyFriendsLimit": {
            changeAppState("friendsLimitDialogState", { type: "myLimit" });
            break;
        }
        case "TheirFriendsLimit": {
            changeAppState("friendsLimitDialogState", {
                type: "theirLimit",
                targetUserId: requesterUserId,
            });
            break;
        }
    }
}
